/**
 * Pure H OS · Sprint 5 · Operations OS shell.
 */
import { NavLink, Outlet } from "react-router-dom";
import {
  LayoutDashboard, FlaskConical, ShieldCheck, PackageOpen, Handshake,
  MoveRight, Truck, ShieldAlert, Factory,
} from "lucide-react";

const SUBNAV = [
  { to: "overview",     label: "Operations Dashboard", icon: LayoutDashboard },
  { to: "batches",      label: "Batches",      icon: FlaskConical    },
  { to: "quality",      label: "Quality",      icon: ShieldCheck     },
  { to: "packaging",    label: "Packaging",    icon: PackageOpen     },
  { to: "suppliers",    label: "Suppliers",    icon: Handshake       },
  { to: "movement",     label: "Movement",     icon: MoveRight       },
  { to: "fulfillment",  label: "Fulfillment",  icon: Truck           },
  { to: "risks",        label: "Risks",        icon: ShieldAlert     },
];

export default function OperationsLayout() {
  return (
    <div data-testid="pureh-operations">
      <div className="mb-4">
        <div className="text-[10px] uppercase tracking-[0.24em] text-slate-500 mb-2 inline-flex items-center gap-1.5">
          <Factory size={11} /> Operations OS
        </div>
        <h1 className="text-3xl font-semibold text-slate-900 tracking-tight">ORVAN Perfumes · Operations</h1>
        <div className="mt-1 text-sm text-slate-500">
          5 batches in flight · 2,560 units in production · 3 open risks · 94.3% OTD
        </div>
      </div>

      <nav data-testid="operations-subnav" className="mb-6 -mx-1 overflow-x-auto">
        <div
          className="inline-flex items-center gap-1 p-1"
          style={{
            background: "var(--ph-surface)",
            border: "1px solid var(--ph-border-subtle)",
            borderRadius: "var(--ph-radius-md)",
          }}
        >
          {SUBNAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`op-subnav-${item.to}`}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium transition-colors"
              style={({ isActive }: { isActive: boolean }) => ({
                background: isActive ? "var(--ph-surface-card)" : "transparent",
                color: isActive ? "var(--ph-ink-strong)" : "var(--ph-ink-muted)",
                borderRadius: "var(--ph-radius-sm)",
                boxShadow: isActive ? "var(--ph-shadow-card)" : "none",
                border: isActive ? "1px solid var(--ph-border-subtle)" : "1px solid transparent",
              })}
            >
              <item.icon size={13} />
              {item.label}
            </NavLink>
          ))}
        </div>
      </nav>

      <Outlet />
    </div>
  );
}
